import(/* webpackMode: "eager", webpackExports: ["PopupAd"] */ "/www/wwwroot/totalsportekes/components/popup-ad.tsx");
;
import(/* webpackMode: "eager" */ "/www/wwwroot/totalsportekes/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/www/wwwroot/totalsportekes/node_modules/next/dist/client/link.js");
